import { root, id } from './clips';
import { suggestions } from './suggestions';

export const clips = {
  ...root,
  id,
  suggestions,
};
